import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

export const REPORT_DATE_FORMAT = "DD-MM-YYYY";

export const parseStoredDateRange = (stored) => {
  if (!stored?.start || !stored?.end) return null;
  const start = dayjs(stored.start, REPORT_DATE_FORMAT, true);
  const end = dayjs(stored.end, REPORT_DATE_FORMAT, true);
  return start.isValid() && end.isValid() ? [start, end] : null;
};

export const serializeDateRange = (range) => {
  const start = range?.[0];
  const end = range?.[1];
  if (!start?.isValid?.() || !end?.isValid?.()) return null;
  return {
    start: start.format(REPORT_DATE_FORMAT),
    end: end.format(REPORT_DATE_FORMAT),
  };
};

export const formatReportDate = (value) =>
  value?.isValid?.() ? value.format(REPORT_DATE_FORMAT) : null;
